@for (column of columns(); track column) {
  @let isSortColumn = currentSortColumn() === column;
  <th
    class="data-table-header"
    [ngStyle]="{
      width: column.width,
      'min-width': column.minWidth,
    }">
    @if (!!column.filterType) {
      <div class="data-table-header-title-container" (click)="sortColumnClicked(column)">
        <div class="data-table-header-title">{{ column.title }}</div>
        @let currentSortIcon = currentSortAsc() ? 'arrow-upward' : 'arrow-downward';
        <mat-icon
          class="data-table-header-cell-icon"
          [class.selected-sort]="isSortColumn"
          [svgIcon]="isSortColumn ? currentSortIcon : 'arrow-downward'">
        </mat-icon>
      </div>
      @if (column.filterType === TableFilterType.text || column.filterType === TableFilterType.textStartsWith) {
        <lib-text-input
          [controlId]="column.id"
          [formControl]="column.filterFormControl"
          [inputSize]="InputSize.small"
          [showClearButton]="column.filterFormControl.value?.length > 0"
          autocomplete="off"
          placeholder="Search..."
          i18n-placeholder>
        </lib-text-input>
      }  @else if (column.filterType === TableFilterType.number) {
        <lib-text-input
          [controlId]="column.id"
          [formControl]="column.filterFormControl"
          [inputSize]="InputSize.small"
          [showClearButton]="column.filterFormControl.value?.length > 0"
          autocomplete="off"
          [attr.inputMode]="'numeric'"
          [maskito]="numericTableFilterMaskitoOptions"
          placeholder="Search..."
          i18n-placeholder>
        </lib-text-input>
      } @else if (column.filterType === TableFilterType.currency) {
        <lib-text-input
          [controlId]="column.id"
          [formControl]="column.filterFormControl"
          [inputSize]="InputSize.small"
          [showClearButton]="column.filterFormControl.value?.length > 0"
          autocomplete="off"
          [attr.inputMode]="'decimal'"
          [maskito]="currencyTableFilterMaskitoOptions"
          placeholder="Search..."
          i18n-placeholder>
        </lib-text-input>
      } @else if (column.filterType === TableFilterType.options) {
        <lib-dropdown-input
          [controlId]="column.id"
          [formControl]="column.filterFormControl"
          [inputSize]="InputSize.small"
          [dropdownItems]="column.filterDropdownItems()"
          placeholder=""
          [dropdownMatchesInputWidth]="false"
          [clearable]="true">
        </lib-dropdown-input>
      } @else if (column.filterType === TableFilterType.date || column.filterType === TableFilterType.dateOnly) {
        <lib-date-input [controlId]="column.id" [formControl]="column.filterFormControl" [inputSize]="InputSize.small">
        </lib-date-input>
      }
    }
  </th>
}
